export const visit = (vm, at) => {
at({ "ja": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u3002E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002" } } } });
};